'use strict';

const AngularHelpers=require('../../../../../dist-es6/client/angularCommon/angularHelpers');

module.exports=AngularHelpers.registerModule({
name:'fdc.features.emiratesDashboard',
dependencies:['ui.router'],
configs:[
require('./emiratesDashboardConfig')],

components:[
require('./emiratesDashboardController'),
require('./components/activityCodeSearchDirective/activityCodeSearchDirective'),
require('./components/autoRefreshDirective/autoRefreshDirective'),
require('./components/staffNumberSearchDirective/staffNumberSearchDirective'),
require('./components/crewRankSelectorDirective/crewRankSelectorDirective'),
require('./components/dutyStatusSelectorDirective/dutyStatusSelectorDirective'),
require('./components/dateTimeSelectorDirective/dateTimeSelectorDirective'),
require('./components/fleetSelectorDirective/fleetSelectorDirective'),
require('./components/pairingDateSelectorDirective/pairingDateSelectorDirective'),
require('./components/flightOrPairingIdSearchDirective/flightOrPairingIdSearchDirective'),
require('./services/emiratesSearchService')]});
//# sourceMappingURL=index.js.map
